import React from "react";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import useSmallNav from "../../../../hooks/useSmallNav";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import pathfinder from "./../../../../assets/info/pathfinder-hero.jpg";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";
import { popularVehicle } from "../../../../vars/popularVehicles";

const NissanPathfinder = () => {
  useSmallNav("Nissan Pathfinder");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Nissan Pathfinder"} bolder />
        <InfoHero image={pathfinder} />
        <InfoGrid>
          <div>
            <p>
              The Hatchback brother of the Navara is here and it's a great all
              round vehicle.
            </p>
            <p>
              Here at Pedders we have a range of suspension parts and kits to
              repair or enhance your Pathfinder.
            </p>
            <p>
              Looking to improve its towing ability? If you tow with or load
              your Pathfinder, you have probably already found they are quite
              soft at the rear. We offer upgrade kits that will allow you to tow
              with more confidence without ruining the comfort and ride of your
              Pathfinder when you are not towing.
            </p>
            <p>
              Looking to raise it for off road use? Then look no further. We
              have those kits too. (not currently available for R51 models).
              Depending on model up to 2.5 inches of lift for increased
              articulation and space for those bigger tyres.
            </p>
            <p>
              If you require suspension parts to replace parts that are worn out
              or failed their MOT, then we have those too. As with all Pedders
              products, whenever we design a new product, we always seek to
              improve on the original, be it for improved performance or
              increased longevity.
            </p>
            <p>
              Still not sure about something? Have a question? Then please do
              get in touch where one of our team will be able to help you.
            </p>
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Nissan")
              .models.find((e) => e.display === "Pathfinder")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
          </div>
        </InfoGrid>
        {/* <InfoFooter make="Nissan" model="Pathfinder" /> */}
      </Container>
    </section>
  );
};

export default NissanPathfinder;
